export var getDurationInMS = (minData, hourData, selectedMinIndex, selectedHourIndex) => {
  var _a, _b, _c, _d;
  var selectedHour = (_b = (_a = hourData[selectedHourIndex]) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : 0;
  var selectedMin = (_d = (_c = minData[selectedMinIndex]) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : 0;
  return (selectedHour * 60 + selectedMin) * 60 * 1000;
};
export var getEpochTime = (minData, hourData, selectedMinIndex, selectedHourIndex) => {
  var currentTime = new Date().getTime();
  return currentTime + getDurationInMS(minData, hourData, selectedMinIndex, selectedHourIndex);
};
export var getContainerView = () => {
  return {
    paddingTop: 40 * 2,
    paddingBottom: 40 * 4.8,
    paddingHorizontal: 20
  };
};
export var getDynamicSelectorView = (isCustomTime, width) => {
  return {
    top: 40 * 2 - 1,
    height: 40,
    width: isCustomTime ? null : width,
    left: isCustomTime ? 0 : null,
    right: isCustomTime ? 0 : null
  };
};